import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet, } from 'react-native';
import { theme } from '@xbto/design-system';
import { flexRender } from '@tanstack/react-table';
import { TextBody } from '../../atoms';
import { useBreakpoints } from '../../hooks';
export const TableContent = ({ table, backgroundInverted, onRowPressed, }) => {
    /**
     * Vars
     */
    const { breakpoints } = useBreakpoints();
    /**
     * DOM
     */
    const rows = table.getRowModel().rows;
    return (_jsx("tbody", { style: StyleSheet.flatten([
            $.dataSection,
            backgroundInverted && $.dataSectionInverted,
        ]), children: rows.map((row, idx) => (_jsx("tr", Object.assign({ style: StyleSheet.flatten([$.dataRow]) }, (!!onRowPressed && { 'data-hoverable': 1 }), { children: row.getVisibleCells().map(cell => {
                var _a, _b;
                const cellWidth = `${cell.column.getSize()}px`;
                const { backgroundColor, justify, autoWidth, height, paddingHorizontal, } = (cell.column.columnDef.meta || {});
                const cellStyles = [
                    $.dataCell,
                    // @ts-expect-error TODO(Benoit): To type ColumnMeta.
                    !!((_b = (_a = cell.column.columnDef.meta) === null || _a === void 0 ? void 0 : _a.isMuted) === null || _b === void 0 ? void 0 : _b.call(_a, row.original)) &&
                        $.dataCellMuted,
                    breakpoints.LESS_THAN_M && $.dataCellSmall,
                    idx === rows.length - 1 && { borderBottomWidth: 0 },
                    {
                        height: height || undefined,
                        maxWidth: autoWidth ? 'auto' : cellWidth,
                        justifyContent: justify || 'flex-end',
                        cursor: onRowPressed ? 'pointer' : 'default',
                        backgroundColor: backgroundColor && theme.color.background[backgroundColor],
                        paddingHorizontal: paddingHorizontal || undefined,
                    },
                ];
                return (_jsx("td", { style: {
                        padding: 0,
                        width: autoWidth ? 'auto' : cellWidth,
                    }, onClick: e => {
                        onRowPressed === null || onRowPressed === void 0 ? void 0 : onRowPressed(row.original, e);
                    }, children: _jsx(TextBody, { style: cellStyles, children: flexRender(cell.column.columnDef.cell, cell.getContext()) }) }, cell.id));
            }) }), `${row.id}-${idx}`))) }));
};
const $ = StyleSheet.create({
    dataSection: {
        backgroundColor: theme.color.background.white,
    },
    dataSectionInverted: {
        backgroundColor: theme.color.background.tertiary,
    },
    dataRow: {
        flexDirection: 'row',
        width: '100%',
        alignItems: 'center',
    },
    dataCell: {
        // @ts-expect-error This is web only
        display: 'inline-flex',
        alignItems: 'center',
        borderBottomColor: theme.color.border.primary,
        borderBottomWidth: 1,
        paddingHorizontal: theme.spacing['6'],
        color: theme.color.text.primary,
        width: '100%',
        height: 62,
    },
    dataCellSmall: {
        paddingHorizontal: theme.spacing['4'],
    },
    dataCellMuted: {
        backgroundColor: theme.color.background.tertiary,
    },
});
